import { EPageType } from 'shared/types/pageType';

/**
 * Выдача — любая: и обычная, и посуточная. На ней поисковая строка живёт под шапкой
 * и реагирует на скролл, в отличие от главной и прочих страниц.
 */
export function isSearchPageType(pageType: EPageType): boolean {
  return pageType === EPageType.SEARCH || pageType === EPageType.SEARCH_RENT_DAILY;
}

/**
 * Выдача посуточной аренды. У неё акцентного синего варианта строки по макету нет —
 * она сразу отрисована свёрнутой и по скроллу вид не меняет.
 */
export function isRentDailyPageType(pageType: EPageType): boolean {
  return pageType === EPageType.SEARCH_RENT_DAILY;
}
